import axios from 'axios'
import {ID} from '../../../../../_metronic/helpers'
import {ResponseObjectPaginated, ResponseObjectUpload} from '../../../models'
import {
  ChangeRoomDetailModel,
  ChangeRoomModel,
  ConfirmChangeRoomModel,
  GetBookingChangeRoomFilter,
} from '../models/change-rooms.model'
const BASEURL = process.env.REACT_APP_DEV_API_HOTELERIA_URL

export function getBookingsChangeRoomsService(dto: GetBookingChangeRoomFilter) {
  return axios.post<ResponseObjectPaginated<ChangeRoomModel[]>>(
    `${BASEURL}/reserve/getListReserveAssignedCheckIn`,
    dto,
  )
}

export async function createChangeRoomService(dto: ConfirmChangeRoomModel) {
  return await axios.post<ResponseObjectUpload>(`${BASEURL}/reserve/createRoomsChange`, dto)
}

export function getBookingsChangeRoomsDetailService(id: ID) {
  return axios.post<ResponseObjectPaginated<ChangeRoomDetailModel[]>>(
    `${BASEURL}/reserve/getListRoomsChange?reservaCamaId=${id}`,
  )
}

export function getBookingsChangeRoomsDocumentsService(id: ID) {
  return axios.post<ResponseObjectPaginated<ChangeRoomDetailModel[]>>(
    `${BASEURL}/reserve/getListRoomsChangeDocs?reservaCamaId=${id}`,
  )
}

export async function aprroveChangeRoomService(id: ID) {
  return await axios.post<ResponseObjectUpload>(
    `${BASEURL}/reserve/ApproveRoomsChange?cambioHabitacioId=${id}`,
  )
}
